import { render, staticRenderFns } from "./goodsList.vue?vue&type=template&id=72474a18&scoped=true"
import script from "./goodsList.vue?vue&type=script&lang=js"
export * from "./goodsList.vue?vue&type=script&lang=js"
import style0 from "./goodsList.vue?vue&type=style&index=0&id=72474a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72474a18",
  null
  
)

export default component.exports